<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">{{ $t('app.filter_by') }}</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">

            <div v-if="!isRoleUserConsultaProvider">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('clients.entity_name') }}</label>
              <el-form-item prop="Cliente" >       
                <base-el-select class="w-full" :options="clientes" v-model="form.Cliente.value" clearable filterable
                  value-key="idCliente" :loading="loadingClientes" />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.name')}}</label>
              <el-form-item prop="NameCorporateName">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.NameCorporateName.value"
                  maxlength="40"
                />
              </el-form-item>
            </div>

            <div v-if="!isRoleUserConsultaProvider">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('companies.cif') }}</label>
              <el-form-item prop="TIN">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.TIN.value"
                  maxlength="40"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('persons_data.firstsurname')}}</label>
              <el-form-item prop="FirstSurname">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.FirstSurname.value"
                  maxlength="40"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('persons_data.secondsurname') }}</label>
              <el-form-item prop="SecondSurname">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.SecondSurname.value"
                  maxlength="40"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('agenda.ResidenceTypeCode')}}</label>
              <el-form-item prop="ResidenceType">
                <base-el-select class="w-full" :options="tiposResidencia" v-model="form.ResidenceType.value" clearable />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('agenda.PersonTypeCode')}}</label>
              <el-form-item prop="PersonType">
                <base-el-select class="w-full" :options="tiposPersona" v-model="form.PersonType.value" clearable />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.Book') }}</label>
              <el-form-item prop="Book">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.Book.value"
                  maxlength="40"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.RegisterOfCompaniesLocation') }}</label>
              <el-form-item prop="RegisterOfCompaniesLocation">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.RegisterOfCompaniesLocation.value"
                  maxlength="40"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.Sheet') }}</label>
              <el-form-item prop="Sheet">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.Sheet.value"
                  maxlength="40"
                />
              </el-form-item>
            </div>
            
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.Folio') }}</label>
              <el-form-item prop="Folio">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.Folio.value"
                  maxlength="40"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.Section') }}</label>
              <el-form-item prop="section">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.Section.value"
                  maxlength="40"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('contacto.Volume') }}</label>
              <el-form-item prop="Volume">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.Volume.value"
                  maxlength="40"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('agenda.additional_data') }}</label>
              <el-form-item prop="AdditionalData">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.AdditionalData.value"
                  maxlength="40"
                />
              </el-form-item>
            </div>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
import { i18n } from '@/i18n'
import { getClients } from '@/services/clients/getClients'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  props: {
    panelOpen: {
      type: Boolean,
      default: false,
    },
    vuexnamespace: {
      type: String,
      default: 'none',
    },
  },
  data: function () {
    return {
      isOpen: this.panelOpen,
      loadingDistribuidores: false,
      loadingClientes: false,
      form: {
        Cliente: { label: i18n.t('clients.entity_name'), value: '' },
        NameCorporateName: { label: i18n.t('app.name'), value: '' },
        TIN: { label: i18n.t('agenda.cif'), value: '' },
        FirstSurname: { label: i18n.t('persons_data.firstsurname'), value: '' },
        SecondSurname: { label: i18n.t('persons_data.secondsurname'), value: '' },
        ResidenceType: { label: i18n.t('agenda.ResidenceTypeCode'), value: '' },
        PersonType: { label: i18n.t('agenda.PersonTypeCode'), value: '' },
        Locations: { label: i18n.t('sedes.header'), value: '' },
        LinkedCompanies: { label: i18n.t('companies.companies_link'), value: '' },
        Book: { label: i18n.t('contacto.Book'), value: '' },
        RegisterOfCompaniesLocation: { label: i18n.t('contacto.RegisterOfCompaniesLocation'), value: '' },
        Sheet: { label: i18n.t('contacto.Sheet'), value: '' },
        Folio: { label: i18n.t('contacto.Folio'), value: '' },
        Section: { label: i18n.t('contacto.Section'), value: '' },
        Volume: { label: i18n.t('contacto.Volume'), value: '' },
        AdditionalData: { label: i18n.t('agenda.additional_data'), value: '' },
      },
      listGroupingBuyers: [],
      listGroupingSellers: [],
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      clientes: [],
    }
  },
  watch: {
    // form: {
    //   deep: true,
    //   immediate: true,
    //   handler: 'watchFormHandler'
    // },
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  mounted: async function () {
    if (this.role === 7 || this.role === 8 || this.role === 3) {
      this.loadingClientes = true
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataClients))
      }
      this.clientes = dataClients.Clientes.map(x => ({ label: x.Nombre, key: x.idCliente, value: { idCliente: x.idCliente, Nombre: x.Nombre } }))
      this.loadingClientes = false
    }
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserConsultaProvider: function () {
      return this.role === 1 || this.role === 4 || this.role === 9
    },
    tiposPersona: function () {
      return this.$store.getters['config/TIPOS_PERSONA']
    },
    tiposRolAgenda: function () {
      return this.$store.getters['config/TIPOS_ROL_AGENDA']
    },
    tiposResidencia: function () {
      return this.$store.getters['config/TIPOS_RESIDENCIA']
    },
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.Cliente.value = _temp.Cliente !== undefined && _temp.Cliente.value !== '' ? _temp.Cliente.value : ''
        this.form.NameCorporateName.value = _temp.NameCorporateName !== undefined && _temp.NameCorporateName.value !== '' ? _temp.NameCorporateName.value : ''
        this.form.TIN.value = _temp.TIN !== undefined && _temp.TIN.value !== '' ? _temp.TIN.value : ''
        this.form.FirstSurname.value = _temp.FirstSurname !== undefined && _temp.FirstSurname.value !== '' ? _temp.FirstSurname.value : ''
        this.form.SecondSurname.value = _temp.SecondSurname !== undefined && _temp.SecondSurname.value !== '' ? _temp.SecondSurname.value : ''
        this.form.ResidenceType.value = _temp.ResidenceType !== undefined && _temp.ResidenceType.value !== '' ? _temp.ResidenceType.value : ''
        this.form.PersonType.value = _temp.PersonType !== undefined && _temp.PersonType.value !== '' ? _temp.PersonType.value : ''
        this.form.Locations.value = _temp.Locations !== undefined && _temp.Locations.value !== '' ? _temp.Locations.value : ''
        this.form.LinkedCompanies.value = _temp.LinkedCompanies !== undefined && _temp.LinkedCompanies.value !== '' ? _temp.LinkedCompanies.value : ''
        this.form.Book.value = _temp.Book !== undefined && _temp.Book.value !== '' ? _temp.Book.value : ''
        this.form.RegisterOfCompaniesLocation.value = _temp.RegisterOfCompaniesLocation !== undefined && _temp.RegisterOfCompaniesLocation.value !== '' ? _temp.RegisterOfCompaniesLocation.value : ''
        this.form.Sheet.value = _temp.Sheet !== undefined && _temp.Sheet.value !== '' ? _temp.Sheet.value : ''
        this.form.Folio.value = _temp.Folio !== undefined && _temp.Folio.value !== '' ? _temp.Folio.value : ''
        this.form.Section.value = _temp.Section !== undefined && _temp.Section.value !== '' ? _temp.Section.value : ''
        this.form.Volume.value = _temp.Volume !== undefined && _temp.Volume.value !== '' ? _temp.Volume.value : ''
        this.form.AdditionalData.value = _temp.AdditionalData !== undefined && _temp.AdditionalData.value !== '' ? _temp.AdditionalData.value : ''
      }
    },
    watchFormHandler: function ({ certificate, send_alerts }) {
      if (certificate !== undefined) {
        this.form.certificate = !!certificate
      }
      if (send_alerts !== undefined) {
        this.form.send_alerts = !!send_alerts
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        Cliente: { label: i18n.t('clients.entity_name'), value: '' },
        NameCorporateName: { label: i18n.t('app.name'), value: '' },
        TIN: { label: i18n.t('agenda.cif'), value: '' },
        FirstSurname: { label: i18n.t('persons_data.firstsurname'), value: '' },
        SecondSurname: { label: i18n.t('persons_data.secondsurname'), value: '' },
        ResidenceType: { label: i18n.t('agenda.ResidenceTypeCode'), value: '' },
        PersonType: { label: i18n.t('agenda.PersonTypeCode'), value: '' },
        Locations: { label: i18n.t('sedes.header'), value: '' },
        LinkedCompanies: { label: i18n.t('companies.companies_link'), value: '' },
        Book: { label: i18n.t('contacto.Book'), value: '' },
        RegisterOfCompaniesLocation: { label: i18n.t('contacto.RegisterOfCompaniesLocation'), value: '' },
        Sheet: { label: i18n.t('contacto.Sheet'), value: '' },
        Folio: { label: i18n.t('contacto.Folio'), value: '' },
        Section: { label: i18n.t('contacto.Section'), value: '' },
        Volume: { label: i18n.t('contacto.Volume'), value: '' },
        AdditionalData: { label: i18n.t('agenda.additional_data'), value: '' },
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    },
  }
}
</script>
